import { render } from "./uploadDoc.vue?vue&type=template&id=7d82c332"
import script from "./uploadDoc.vue?vue&type=script&lang=js"
export * from "./uploadDoc.vue?vue&type=script&lang=js"

import exportComponent from "C:\\devPrivate\\cmsDubaiMailing\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__